import { ViewType } from '~/models/shared/types'
import { SearchConfig } from '~/models/search/config'

export const adminSearchConfig: SearchConfig = Object.freeze({
  settings: {
    isAdminSearch: true,
    viewType: {
      defaultViewTypeDesktop: ViewType.LIST,
      defaultViewTypeMobile: ViewType.LIST
    },
    searchbar: {
      autocompleteUrl: '/api/admin/classifieds/query/'
    },
    rowsTarget: 'admin-classified-view'
  },
  rootParams: {
    admin: ['1']
  }
})
